module.exports = __webpack_public_path__ + "img/11.b9ee5945.png";